module.exports = __webpack_public_path__ + "static/media/Image 30@2x.194d8a17.png";